"use strict";

(function () {
  'use strict';

  function ConnectionCtrl($filter, ConnectionsService, LRNotification) {
    var vm = this;
    this.initial = true;
    this.loading = false;
    this.approving = false;
    this.connections = {};

    var _getConnectionsList = function _getConnectionsList() {
      vm.loading = true;
      ConnectionsService.getList().then(function (data) {
        data = data.map(function (connection) {
          if (connection.hasOwnProperty('dateApproved') && connection.dateApproved) {
            connection.approved = 1;
          } else {
            connection.approved = 0;
          }

          return connection;
        });
        vm.loading = false;
        vm.approving = false;
        vm.initial = false;
        vm.connections = $filter('groupBy')(angular.copy(data), 'approved');
      }, function (error) {
        console.log(error);
        vm.loading = false;
        vm.approving = false;
        vm.initial = false;
      });
    };

    this.approve = function (id) {
      vm.approving = id;
      ConnectionsService.approve(id).then(function (data) {
        LRNotification.success('Connection Successful');

        _getConnectionsList();
      }, function (error) {
        console.log(error);
      });
    };

    this.$onInit = function () {
      _getConnectionsList();
    };
  }

  ConnectionCtrl.$inject = ['$filter', 'ConnectionsService', 'LRNotification'];
  angular.module('view.account').component('connections', {
    bindings: {},
    controller: ConnectionCtrl,
    templateUrl: 'views/account/components/connections/connections.html'
  });
})();